import ArchivedSection from "../molecules/ArchivedSection";

export default function ArchivedPage() {
  return (
    <div className="flex min-h-screen bg-gray-100">
      <main className="flex-1 max-w-4xl mx-auto mt-6 h-[calc(100vh-48px)] overflow-auto">
        <ArchivedSection />
      </main>
    </div>
  );
}
